import type { ReactNode } from 'react'
import { useLogout } from '@refinedev/core'
import { ThemedSider } from '@refinedev/antd'
import { App, Menu } from 'antd'
import { LogoutOutlined, ExclamationCircleOutlined } from '@ant-design/icons'

interface CustomSiderProps {
  Title?: (props: { collapsed: boolean }) => ReactNode
}

export const CustomSider = ({ Title }: CustomSiderProps) => {
  const { mutate: logout } = useLogout()
  // Use the App-context modal (not the static Modal.confirm): under React 19 the
  // static methods can't consume context and silently fail to render. The app is
  // wrapped in <AntdApp>, so App.useApp() gives a working, theme-aware modal.
  const { modal } = App.useApp()

  const handleLogoutClick = () => {
    modal.confirm({
      title: 'Odjava',
      icon: <ExclamationCircleOutlined />,
      content: 'Da li ste sigurni da zelite da se odjavite?',
      okText: 'Da, odjavi me',
      cancelText: 'Odustani',
      okButtonProps: { danger: true },
      onOk: () => {
        logout()
      },
    })
  }

  return (
    <ThemedSider
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Title={Title as any}
      render={({ items, collapsed }: { items: ReactNode; collapsed: boolean }) => (
        <>
          {items}
          <Menu
            selectedKeys={[]}
            mode="inline"
            style={{
              marginTop: 'auto',
              borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            }}
            theme="dark"
            items={[
              {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: collapsed ? '' : 'Odjavi se',
                onClick: handleLogoutClick,
              },
            ]}
          />
        </>
      )}
    />
  )
}
